<template>
    <div class="product-create">
        <b-container>
            <h1>Create Product</h1>

            <b-form @submit="submit">
                <b-form-group label="Please enter the product code:">
                    <b-form-input id="product-code" v-model="productCode" autofocus></b-form-input>
                </b-form-group>

                <b-button type="submit" class="btn-lg">Create</b-button>
            </b-form>
        </b-container>
    </div>
</template>

<script>
export default {
  name: 'productCreate',
  props: ['fb'],
  data () {
    return {
      productCode: ''
    }
  },
  firebase () {
    return {
      products: this.fb.database().ref('products')
    }
  },
  methods: {
    submit () {
      this.$firebaseRefs.products.child(this.productCode).set({
        code: this.productCode
      })

      this.$router.push('/product/' + this.productCode)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ProductCreate.vue